<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OicFuV/tc-custom/9781684814671.jpg?1732164947482" alt="This image is the cover for the book Women Who Murder"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Women Who Murder
      </h1>
      <p class="bookDescription body article font2">
        <b>Female Serial Killers Through Time</b><p><b>From historical accounts to modern cases, explore the captivating psychology behind these killer women, unraveling their motives and unveiling the dark complexities of human behavior.</b></p><p><b>The fair sex.</b> We’ve often heard this clichéd expression being used to refer to women. Although it has become increasingly outdated, the mindset still exists that women are the gentle and nurturing sex. When it comes to murder, that notion gets turned on its head. And this isn’t a recent phenomenon; we can find plenty of female killers going back in history. In fact, some of the world’s most notorious serial killers have been women. These female killers give their male counterparts a run for their money, and deserve to be counted among the most famous serial killers. </p><p><b>Unearth the disturbing histories of notorious women.</b> From the chilling accounts of infamous black widow murders to the spine-tingling narratives of women who shocked the world with their sinister deeds, this anthology delves deep into the minds of these deadly women. Spanning eras and continents, these tales of true crime offer a chilling exploration of the darkest corners of human nature.</p><p><b>Inside:</b></p>Discover lesser-known cases of female killers that challenge conventional narratives and shed light on the often-overlooked stories of women who defied societal norms and perpetrated gruesome crimes.Enjoy a diverse selection of true crime tales that spotlight the narratives of female serial killers from various historical periods.Explore the international spectrum of female murderers and uncover how factors such as culture, upbringing, and personal experiences contribute to the making of these deadly women.<p></p><p><b>If you liked books such as <i>Lady Killers</i>, <i>The Big Book of Serial Killers</i>, or <i>The Best New True Crime Stories</i>, you’ll love <i>Women Who Murder</i>.</b></p>

      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mitzi Szereto
      </h2>
      
      <p class="authorDescription body article"><P><B>Mitzi Szereto</B> (mitziszereto.com) is an American-British author, anthology editor, and short story writer. Her latest books are those in <I>The Best New True Crime Stories </I>series (now numbering seven volumes). A contribution from her anthology <I>Getting Even: Revenge Stories</I> received the Crime Writers Association Short Story Dagger &#8220;Highly Commended.&#8221; Mitzi edited the first erotic fiction anthology to include a Fellow of the Royal Society of Literature. She&#8217;s appeared on TV, radio, and at literature festivals around the world, presented the web channel Mitzi TV, and portrayed herself in the mockumentary film, <I>Lint: The Movie</I>. Follow her on Twitter, Instagram, TikTok, and Facebook @mitziszereto. She lives in Seattle.</P>&#10;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Mango Publishing Group
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?57148c94